// import { useState } from 'react';
import { useTheme } from '@material-ui/core';
import DataTableNativeML from '@/components/DataTableNativeML';
import ResultListStyled from './ResultListStyled';
import { history } from 'umi';
import { useSelector } from 'dva';
import { useIntl } from 'umi';
import { transNum, fmtThousand } from '@/utils/comUtil';
import { orderSourceMapList } from '@/constants';
const ResultList = (props) => {
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const pageData = props.pageData;
  const { handlePageChange } = props;
  const theme = useTheme();
  const loadingEffect = useSelector((state) => state.loading);
  const loading = loadingEffect.effects['orderList/getOrderList'];
  const { data: orderList, hasNext } =
    useSelector((state) => state.orderList?.orderList) || {};
  const {
    saleOrderQuantity = 0,
    returnOrderQuantity = 0,
    sales = 0,
  } = useSelector((state) => state.orderList?.orderSummary) || {};
  const { pathname } = history.location;
  //订单类型
  const typeList = [
    { name: '正单', value: 'SALE_ORDER' },
    { name: '退单', value: 'REFUND_RETURN' },
  ];
  //订单来源
  // const channelList = [
  //   { name: '门店', value: 'STORE' },
  //   { name: '小程序', value: 'MINIPROGRAM' },
  //   { name: '官网', value: 'WEBSITE' },
  // ];
  const columns = [
    {
      align: 'center',
      title: formatMessage({ id: 'order.order.n01.lbl02' }),
      id: 'orderNo',
      event: {
        onClick: (value, row) => {
          history.push({
            pathname:
              pathname === '/dealer/order_list'
                ? '/dealer/order_list/order_detail'
                : '/cm/order_list/order_detail',
            query: { id: row.id },
          });
        },
      },
      render: (row) => {
        return (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            data-log={JSON.stringify({
              oid: 'link_offline_order_management_list_order_no_link',
              events: ['_ev', '_ec'],
              params: {
                order_no: row.id,
                initUrl: window.location.origin + window.location.pathname,
              },
            })}
            className="url-point-style"
          >
            {row.orderNo}
          </a>
        );
      },
      width: '200',
    },
    {
      title: formatMessage({ id: 'order.order.n01.lbl04' }),
      align: 'center',
      id: 'memberCode',
      // key: 'comment',
      // width: 120,
    },
    {
      title: formatMessage({ id: 'order.order.c01.lbl03' }),
      align: 'center',
      id: 'orderType',
      // key: 'typeName',
      render: (rows) => {
        const name = typeList.find((i) => i.value === rows.orderType)?.name;
        return <div>{name}</div>;
      },
    },
    {
      title: formatMessage({ id: 'order.order.c01.lbl04' }),
      id: 'amountPaid',
      // key: 'usedTypeName',
      // width: 120,
      align: 'center',
      render: (rows) => {
        return <div>{fmtThousand(rows.amountPaid)}</div>;
      },
    },
    {
      title: formatMessage({ id: 'order.order.c01.lbl05' }),
      align: 'center',
      id: 'channel',
      // width: 220,
      render: (rows) => {
        const name = orderSourceMapList.find(
          (i) => i.id === rows.channel,
        )?.name;
        return <div>{name}</div>;
      },
    },
    // {
    //   title: formatMessage({ id: 'order.order.c01.lbl06' }),
    //   align: 'center',
    //   id: 'storeName',
    //   // width: 120,
    // },
    {
      title: formatMessage({ id: 'order.order.c01.lbl07' }),
      align: 'center',
      id: 'tradeTime',
      // width: 120,
    },
  ];

  //换页
  const changePage = (obj) => {
    handlePageChange(obj);
  };
  const fOrderList =
    Array.isArray(orderList) && orderList.length > 0
      ? orderList.map((item) => {
          item.orderItemList && delete item.orderItemList;
          return item;
        })
      : [];
  const headerTip = (
    <div className="number-wrapper">
      <div className="number">
        <span className="text">
          {formatMessage({ id: 'order.order.c01.lbl08' })}{' '}
        </span>
        <span>{transNum(saleOrderQuantity)}</span>
        <span className="line">｜</span>
        <span className="text">
          {formatMessage({ id: 'order.order.c01.lbl09' })}{' '}
        </span>
        <span>{transNum(returnOrderQuantity)}</span>
        <span className="line">｜</span>
        <span className="text">
          {formatMessage({ id: 'order.order.c01.lbl10' })}{' '}
        </span>
        <span>{transNum(sales)}</span>
      </div>
    </div>
  );
  return (
    <ResultListStyled theme={theme}>
      <DataTableNativeML
        headerTip={headerTip}
        columns={columns}
        changePage={changePage}
        page={pageData}
        data={fOrderList}
        hasNext={hasNext}
        initP={true}
        paging={true}
        columnKey="id"
        loading={loading}
      ></DataTableNativeML>
    </ResultListStyled>
  );
};
export default ResultList;
